var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "multi-selection-table-container no-select scroll-fire-fox"
    },
    [
      _c(
        "table",
        { staticClass: "multi-selection-table", attrs: { id: "table" } },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm._l(_vm.objects, function(object, objectIndex) {
            return _c("tr", { key: objectIndex, staticClass: "table-body" }, [
              _c("td", { staticClass: "object-index" }, [
                _vm._v("\n        " + _vm._s(objectIndex + 1) + "\n      ")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "input-disabled" }, [
                _vm._v("\n        " + _vm._s(object.layer) + "\n      ")
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "input-disabled" }, [
                _vm._v(
                  "\n        " + _vm._s(object[_vm.prefix + "_id"]) + "\n      "
                )
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "input-disabled" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      object.hasOwnProperty(_vm.prefix + "_label")
                        ? object[_vm.prefix + "_label"]
                        : "-"
                    ) +
                    "\n      "
                )
              ])
            ])
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "table-header" }, [
      _c("th", { staticClass: "object-index" }),
      _vm._v(" "),
      _c("th", [_vm._v("Layer")]),
      _vm._v(" "),
      _c("th", [_vm._v("ID")]),
      _vm._v(" "),
      _c("th", [_vm._v("Label")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-215e40f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-215e40f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Organisms/MultipleObjectsMultipleLayersTable.vue
// module id = null
// module chunks = 